<script>
import baseMixin from '@/mixins/baseMixin'
import ColorSet from '@/models/general/colorSet'
import UserAvatar from '@/components/user/user-avatar.vue'

export default {
  name: 'CommentBaseAvatar',
  components: { UserAvatar },
  mixins: [baseMixin],
  props: {
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    color: {
      type: ColorSet,
      default: () => null,
    },
  },
}
</script>

<template>
  <UserAvatar
    :name="name"
    :icon="icon"
    :color-set="color"
    size="40"
    class="mr-4"
  />
</template>
